<section class="container">
  <a class="btn m-10" (click)="openModal()">افزودن پکیج</a>

  <section class="">
    <div class="row kp-card" *ngFor="let package of packages;let i=index">
      <header class="fs-sm f-gray">
        <span class="float-left">
          <ng-container *ngFor="let kind of package.Kinds">{{Kind[kind]}} | </ng-container>
          <i class="fa fa-edit pointer m-1" (click)="openModal(package)" title="ویرایش"></i>
          <i class="fa fa-trash pointer m-1" (confirm)="delete(package.Id)" title="حذف"></i>
        </span>
      </header>
      <img *ngIf="package.Image" [src]="imageUrl+package.Image" style="max-width:150px;max-height:150px">
      <h3>{{package.Title}} - {{package.Key}} <ng-container *ngIf="package.IsDisabled">[غیرفعال]</ng-container>
      </h3>
      <h6>{{package.IsCpc ? 'کلیکی' : 'تعرفه‌ای'}}</h6>
      <div class="col-12 row" *ngIf="package.IsCpc">
        <div class="col">مینیموم بودجه: {{package.MinBudget|number}}</div>
        <div class="col">ماکزیموم بودجه: {{package.MaxBudget|number}}</div>
        <div class="col-1"><a [routerLink]="['/employer','postad',package.Key]" target="_blank">ثبت آگهی</a></div>
      </div>
      <ng-container *ngIf="!package.IsCpc">
        <div class="col-12 row" *ngFor="let price of package.Prices">
          <div class="col-8">{{price.Title}}</div>
          <div class="col">{{price.Days|number}} روز اعتبار</div>
          <div class="col">{{price.Price|number}} تومان</div>
          <div class="col-1"><a [routerLink]="['/employer','postad',package.Key+'-'+price.Days]" target="_blank">ثبت
              آگهی</a></div>
        </div>
      </ng-container>
    </div>
  </section>
</section>

<ngx-smart-modal #packageModal identifier="packageModal">
  <ngx-spinner name="action" [fullScreen]="false" type="timer"></ngx-spinner>
  <div class="container mt-5">
    <div class="row">
      <div class="col-12 row">
        <div class="col form-group">
          <input type="file" #file (change)="loadImage(file.files[0])" style="display:none;" accept=".jpg,.jpeg,.png">
          <button class="btn" type="button" (click)="file.click()">انتخاب تصویر</button>
        </div>
        <img *ngIf="preview" class="col-2" [src]="preview" style="max-width:150px;max-height:150px">
      </div>
      <div class="col-6 form-group">
        <input type="text" name="title" placeholder="عنوان" [(ngModel)]="selected.Title">
      </div>
      <div class="col-6 form-group">
        <input type="text" dir="ltr" name="key" placeholder="شناسه" [(ngModel)]="selected.Key">
      </div>
      <div class="col-12">
        <textarea class="w-100" name="html" dir="ltr" rows="5" placeholder="کد html"
          [(ngModel)]="selected.Html"></textarea>
      </div>
      <div class="col-6 form-group">
        <label>
          <input type="checkbox" name="isdisabled" [(ngModel)]="selected.IsDisabled">
          <span>غیرفعال</span>
        </label>
      </div>
      <div class="col-6 form-group">
        <label>
          <input type="checkbox" name="iscpc" [(ngModel)]="selected.IsCpc">
          <span>پکیج کلیکی</span>
        </label>
      </div>
      <ng-container *ngIf="selected.IsCpc">
        <div class="col-6 form-group">
          <label>
            <input type="number" inputmode="numeric" name="min-budget" min=0 [max]="selected.MaxBudget" [(ngModel)]="selected.MinBudget">
            <span>مینیموم بودجه</span>
          </label>
        </div>
        <div class="col-6 form-group">
          <label>
            <input type="number" inputmode="numeric" name="max-budget" [min]="selected.MinBudget" [(ngModel)]="selected.MaxBudget">
            <span>ماکزیموم بودجه</span>
          </label>
        </div>
      </ng-container>
      <div class="col-6 form-group">
        <label>
          <input type="checkbox" name="kind-call" [ngModel]="selected.Kinds?.includes(Kind.Call)" (ngModelChange)="toggleKind(Kind.Call)">
          <span>متقاضی کار باهاشون تماس بگیره</span>
        </label>
        <label>
          <input type="checkbox" name="kind-basic" [ngModel]="selected.Kinds?.includes(Kind.Basic)" (ngModelChange)="toggleKind(Kind.Basic)">
          <span>اطلاعات اولیه بده، خودشون تماس بگیرن</span>
        </label>
        <label>
          <input type="checkbox" name="kind-resume" [ngModel]="selected.Kinds?.includes(Kind.Resume)" (ngModelChange)="toggleKind(Kind.Resume)">
          <span>رزومه کامل ارسال کنه تا بررسی کنن</span>
        </label>
      </div>
    </div>
    <ng-container *ngIf="!selected.IsCpc">
      <div class="container border m-1 p-1" *ngFor="let price of selected.Prices;let i=index">
        <div class="form-group">
          <input type="text" placeholder="عنوان" [(ngModel)]="price.Title">
        </div>
        <div class="row">
          <div class="col-6 form-group">
            <input type="number" inputmode="numeric" dir="ltr" placeholder="اعتبار - روز" [(ngModel)]="price.Days">
          </div>
          <div class="col-6 form-group">
            <input type="number" inputmode="numeric" dir="ltr" placeholder="مبلغ - تومان" [(ngModel)]="price.Price">
          </div>
        </div>
        <i class="fa fa-trash pointer" (click)="selected.Prices.splice(i,1)" title="حذف قیمت"></i>
      </div>
    </ng-container>
    <div class="btn-group">
      <button class="btn btn-gray" *ngIf="!selected.IsCpc" (click)="selected.Prices.push(Object.assign({}))">افزودن
        قیمت</button>
      <button class="btn btn-yellow" type="submit" (click)="save()">ذخیره</button>
    </div>
  </div>
</ngx-smart-modal>